import { reducer } from './store/general-slice';

export default {
  reducer,
};
